import React from "react";
import * as Styled from "./styles";
import ButtonPrimary from "Components/Buttons/Primary";

interface Props {
  onLogin: () => void;
  onCancel: () => void;
}

const UserDontExistsModal: React.FC<Props> = ({ onLogin, onCancel }) => {
  return (
    <Styled.Overlay>
      <Styled.Modal>
        <Styled.Title>
          Não há usuário cadastrado para os dados informados
        </Styled.Title>
        <Styled.Message>
          {`Não existe nenhum usuário cadastrado com este email ou CPF/CNPJ.
            Favor realize o cadastro e posteriormente será automáticamente reencaminhado para concluir o cadastro da loja`}
        </Styled.Message>
        <Styled.Question>
          Deseja para o cadastro de usuário ou tentar outro email ou CPF/CNPJ?
        </Styled.Question>
        <Styled.ButtonContainer>
          <ButtonPrimary action={onLogin} color="green">
            Cadastrar usuário
          </ButtonPrimary>
          <Styled.CancelButton onClick={onCancel}>
            Tentar com outros dados
          </Styled.CancelButton>
        </Styled.ButtonContainer>
      </Styled.Modal>
    </Styled.Overlay>
  );
};

export default UserDontExistsModal;
